import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';

// Personal details fetch
export const personalDetails = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.account.personal.getPersonalDetail);
        if (!response.data.error) {
            dispatch({
                type: API.account.personal.getPersonalDetail,
                personalDetailsData: response.data.data,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

// Update personal details
export const updatePersonalDetails = (payload) => async () => {
    try {
        const response = await DataService.put(API.account.personal.updatePersonalDetail, payload);
        if (!response.data.error) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

// Update membership
export const updateUserMembershipDetail = (id, body) => async () => {
    try {
        const response = await DataService.post(API.account.personal.updateMembership + id, body);
        if (!response.data.error) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
// Personal details fetch
export const configDetails = () => async (dispatch) => {
    try {
        const response = await DataService.get(API.config.get);
        if (response.status == 200) {
            dispatch({
                type: API.config.get,
                configDetails: response.data.data.config,
                loading: false,
            });
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

//Update hour change
export const updateShopConfigApi = (body) => async (dispatch) => {
    try {
        const response = await DataService.put(API.config.shopUpdate, body);
        if (response.status == 200) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

//Shop hour change
export const updateBufferConfigApi = (body) => async (dispatch) => {
    try {
        const response = await DataService.put(API.config.put, body);
        if (response.status == 200) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
